var $, perflibLoader;

perflibLoader = require('../../src/frontend/core/perflibLoader');

perflibLoader();

$ = window.$ = window.jQuery = require('jquery');

require('../../src/frontend/core/jquery.safe-ready')($);

require('../../src/frontend/core/jquery.addons')($);

require('./groupon_modules/placeholder_field')($);

require('./common/core_libraries');

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvbHMtY29yZS12TUlOT1JfVi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvY29yZS9mcm9udGVuZC9scy1jb3JlLXZNSU5PUl9WLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLHVDQUFSOztBQUNoQixhQUFBLENBQUE7O0FBQ0EsQ0FBQSxHQUFJLE1BQU0sQ0FBQyxDQUFQLEdBQVcsTUFBTSxDQUFDLE1BQVAsR0FBZ0IsT0FBQSxDQUFRLFFBQVI7O0FBQy9CLE9BQUEsQ0FBUSwyQ0FBUixDQUFBLENBQXFELENBQXJEOztBQUNBLE9BQUEsQ0FBUSx1Q0FBUixDQUFBLENBQWlELENBQWpEOztBQUNBLE9BQUEsQ0FBUSxxQ0FBUixDQUFBLENBQStDLENBQS9DOztBQUNBLE9BQUEsQ0FBUSx5QkFBUiJ9
